import React, { FC } from 'react';
import { TypeBadgeFields } from '@/core/generated-types';
import { TW_BADGE_COLORS } from '@/core/constants';

export interface TypeBadgeProps extends TypeBadgeFields {
  classes?: string;
}
const Badge: FC<TypeBadgeProps> = (fields) => {
  const { badgeColor = 'Indigo', text, classes = '' } = fields;
  const { bg, textColor } = TW_BADGE_COLORS[badgeColor];

  return (
    <div
      data-testid="badge"
      className={`badge badge-md rounded-3xl md:badge-lg ${bg} !h-auto px-4 py-1 !text-sm ${textColor} whitespace-nowrap font-bold ${classes}`}
    >
      {text}
    </div>
  );
};

export default React.memo(Badge);
